import { createPopper } from '@popperjs/core';

export class WbPopper {
  constructor() {}

  init() {
    return new Promise(resolve => {
      this.createTooltips();
      resolve();
    });
  }

  createTooltips() {
    document.querySelectorAll('.wb-popper')?.forEach(el => {
      const id = el.getAttribute('aria-describedby');
      const tooltip = document.querySelector(`#${id}`);
      const showEvents = ['mouseenter', 'focus'];
      const hideEvents = ['mouseleave', 'blur'];
      const popperInstance = createPopper(el, tooltip, {
        placement: 'top',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
        ],
      });

      function show() {
        tooltip.setAttribute('data-show', '');

        popperInstance.setOptions(options => ({
          ...options,
          modifiers: [...options.modifiers, { name: 'eventListeners', enabled: true }],
        }));

        popperInstance.update();
      }

      function hide() {
        tooltip.removeAttribute('data-show');

        popperInstance.setOptions(options => ({
          ...options,
          modifiers: [...options.modifiers, { name: 'eventListeners', enabled: false }],
        }));
      }

      showEvents.forEach(event => {
        el.addEventListener(event, show);
      });

      hideEvents.forEach(event => {
        el.addEventListener(event, hide);
      });

      el.addEventListener('click', e => {
        const visibility = tooltip.getAttribute('data-show');

        if (visibility !== null) hide();
        else show();
      });
    });
  }
}
